export default __webpack_public_path__ + "static/media/0.63.40710dc0.jpg";